import React from 'react';
import { connect } from 'react-redux';
import styles from './ButtonPic.scss';
import { Avatar as IAvatar } from '@wix/chat-web';
import Avatar from '../Avatar/Avatar';
import { primaryColorOrDefault } from '../../reducers';
import { Tooltip } from 'wix-style-react';

interface ButtonProps {
  onClick(): any;
  dataHook?: string;
  avatar: IAvatar;
  primaryColor: string;
}

export class ButtonPic extends React.Component<ButtonProps> {
  render() {
    const { onClick, dataHook, avatar, children, primaryColor } = this.props;

    return (
      <div>
        <Tooltip
          fixed
          content={children}
          dataHook={'button-tooltip'}
          size={'small'}
        >
          <button
            className={styles.button}
            data-hook={dataHook || 'widget-button-pic'}
            onClick={onClick}
          >
            <div className={styles.buttonPicDiv}>
              <Avatar avatar={avatar} size={36} />
            </div>
            <div className={styles.buttonXDiv}>
              <DeletePic size={'16'} primarycolor={primaryColor} />
            </div>
          </button>
        </Tooltip>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    primaryColor: primaryColorOrDefault(state),
  };
}

export const ThemedButton = connect(mapStateToProps)(ButtonPic);
export default ThemedButton;

interface deletePicProps extends React.SVGAttributes<SVGElement> {
  size?: string;
  primarycolor: string;
}
const DeletePic: React.FunctionComponent<deletePicProps> = ({
  size,
  ...props
}) => (
  <svg
    viewBox="0 0 16 16"
    fill={props.primarycolor}
    width={size || '16'}
    height={size || '16'}
    {...props}
  >
    <g
      id="SOCIAL-CHAT"
      stroke="none"
      fill="none"
      strokeWidth="1"
      fillRule="evenodd"
    >
      <g id="ICONS" transform="translate(-700 -44)" stroke="#FFFFFF">
        <g id="X-Delete" transform="translate(701 45)">
          <circle id="Oval" fill={props.primarycolor} cx="7" cy="7" r="7" />
          <path
            d="M4.84615385,4.84615385 L9.15384615,9.15384615"
            id="Line"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.84615385,4.84615385 L9.15384615,9.15384615"
            id="Line-Copy"
            transform="matrix(-1 0 0 1 14 0)"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
